module.exports = __webpack_public_path__ + "img/evaluate.0c82e2aa.png";